import { useAutobidAuth } from '@autobid/nuxt-auth/src/composables/useAutobidAuth'
import { computed } from 'vue'
import { useCurrencies } from './useCurrencies'
import { useProfile } from './useProfile'

/**
 * Retrieves the user's currency from the store and returns the corresponding currency object from the list of available currencies.
 */
export function useUserCurrency() {
  const { data: profile } = useProfile()
  const { isAuthed } = useAutobidAuth()
  const { data: currencies } = useCurrencies(isAuthed)

  return computed(() => {
    return {
      ...currencies.value?.find(
        currency => currency.id === profile.value?.currency?.code,
      ),
      ...profile.value?.currency,
    }
  })
}
